import { FormikProps } from 'formik';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { useTranslation } from 'react-i18next';
import {
  CustomerCreditInfo,
  CustomerFormType,
} from 'types/customer/customerTypes';

export default function TopLabelCustomerCreditSection({
  formik,
}: {
  formik: FormikProps<CustomerFormType>;
}) {
  const { t } = useTranslation();
  const { showAllValidateErrors } = useSelector((s: RootState) => s.Customer);

  const err = (path: keyof CustomerCreditInfo) =>
    ((formik.touched.customerCreditInfo as any)?.[path] &&
      (formik.errors.customerCreditInfo as any)?.[path] &&
      typeof (formik.errors.customerCreditInfo as any)[path] === 'string') ||
    (formik.isValid === false &&
      (formik.errors.customerCreditInfo as any)?.[path] &&
      showAllValidateErrors === true);

  return (
    <>
      {/* <div className="mb-3" style={{ fontSize: '16px', fontWeight: '600' }}> */}
      <div className="mb-4 accent-bar">{t('Credit Information')}</div>
      <div className="row">
        <Col sm={12}>
          <FormGroup>
            <Label htmlFor="customerCreditInfo.receivableLimit">
              {t('Receivable Limit')}
            </Label>

            <Input
              type="number"
              inputMode="decimal"
              step="0.01"
              min="0"
              id="customerCreditInfo.receivableLimit"
              name="customerCreditInfo.receivableLimit"
              className="form-control"
              value={formik.values.customerCreditInfo.receivableLimit}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {err('receivableLimit') ? (
              <div className="text-danger">
                {(formik.errors.customerCreditInfo as any).receivableLimit}
              </div>
            ) : null}
          </FormGroup>
        </Col>
      </div>

      <div className="row">
        <Col sm={12}>
          <FormGroup>
            <Label htmlFor="customerCreditInfo.dateLimit">
              {/* {t('Overdue Days Limit')} */}
              {t('Date Limit')}
            </Label>

            <Input
              type="number"
              inputMode="numeric"
              step="1"
              min="0"
              id="customerCreditInfo.dateLimit"
              name="customerCreditInfo.dateLimit"
              className="form-control"
              value={formik.values.customerCreditInfo.dateLimit}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {err('dateLimit') ? (
              <div className="text-danger">
                {(formik.errors.customerCreditInfo as any).dateLimit}
              </div>
            ) : null}
          </FormGroup>
        </Col>
      </div>
      <div className="mb-3 row"></div>
    </>
  );
}
